import { AdminMenuBar } from "../../AdminMenuBar";
import Address from "../../../Address";
import { useState, useEffect, useRef } from "react";

import { updateProductTitle } from "../../../../services/ProductAPI";

import {
    Button,
    useDisclosure,
    Input,
    InputGroup,
    InputRightElement,
    Stack,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

import ProductAdditionModal from "./ProductAdditionModal";

const ProductAndSolution = (props) => {
    const [name, setName] = useState(props.titleText);
    const [file, setFile] = useState("");
    const [initialTitleName, setInitialTitleName] = useState("선택된 파일이 없습니다");

    const [imgBase64, setImgBase64] = useState(null); // 파일 base64
    const inputRef = useRef(null);

    const editModal = useDisclosure();
    const additionModal = useDisclosure();

    useEffect(() => {
        setName(props.titleText);
        setFile("");
        setInitialTitleName(getInitialTitleImageName());
    }, []);

    const openFileExplorer = () => {
        inputRef.current.click();
    };

    const getInitialTitleImageName = () => {
        let lastSlashIndex = props.titleImage.lastIndexOf("/");
        return props.titleImage.substr(lastSlashIndex + 1);
    };

    const fileChange = (event) => {
        setFile(event.target.files[0]);

        setImgBase64([]);

        for (var i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i]) {
                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
                // 파일 상태 업데이트
                reader.onloadend = () => {
                    // 2. 읽기가 완료되면 아래코드가 실행.
                    const base64 = reader.result;
                    if (base64) {
                        // 문자 형태로 저장
                        var base64Sub = base64.toString();
                        // 배열 state 업데이트
                        setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
                    }
                };
            }
        }
    };

    const updateTitleInfo = () => {
        updateProductTitle(name, file).then(() => {
            props.setIsProductUpdated(true);
            alert("배너 정보가 수정되었습니다!");
        });
        editModal.onClose();
    };

    const openTitleEditModal = () => {
        setName(props.titleText);
        setInitialTitleName(getInitialTitleImageName());
        editModal.onOpen();
    };

    const openAdditionModal = () => {
        additionModal.onOpen();
    };

    const removeFile = () => {
        setFile("");
        setImgBase64(null);
    };

    return (
        <div className="h-screen w-screen overflow-x-hidden">
            <AdminMenuBar selected_page={props.selected_page} />

            <div className="w-full bg-white font-bold">
                <div
                    className="w-full h-[300px] bg-black text-8xl font-bold text-white flex items-center justify-center bg-[length:100%_100%]"
                    style={{ backgroundImage: `url(${props.titleImage})` }}
                >
                    {props.titleText}
                </div>

                <div className="p-[10px] flex justify-end">
                    <div className="flex items-end mr-[10px]">
                        <div className="text-2xl">버튼을 클릭해 상단 배너 정보를 편집할 수 있습니다</div>
                    </div>
                    <Button
                        colorScheme="green"
                        fontSize="3xl"
                        px="10px"
                        py="20px"
                        onClick={() => {
                            openTitleEditModal();
                        }}
                    >
                        배너 편집
                    </Button>
                </div>
                <div className="flex justify-end items-center pr-[10px]"></div>

                <div className="w-full flex justify-center items-center mt-[100px]">
                    <div>
                        <div className="flex items-end">
                            <Button
                                colorScheme="blue"
                                fontSize="3xl"
                                px="10px"
                                py="20px"
                                onClick={() => openAdditionModal()}
                            >
                                제품 추가
                            </Button>
                            <div className="flex items-end ml-[10px]">
                                <div>
                                    <div className="text-2xl">버튼을 클릭해 제품 정보를 추가할 수 있습니다</div>
                                    <div className="text-2xl">
                                        제품 정보를 [편집]하거나 [삭제]하려면 각 제품 하단에 있는 버튼을 클릭해 주세요
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end items-center mt-[10px]"></div>
                        <div className="certificate_grid_container">{props.cardList}</div>
                    </div>
                </div>
            </div>
            <Address />

            <Modal onClose={editModal.onClose} isOpen={editModal.isOpen} isCentered>
                <ModalOverlay />

                <ModalContent maxW="500px">
                    <ModalHeader p="20px">
                        <div className="text-4xl pb-[10px]">편집</div>
                        <div className="text-2xl">텍스트 박스를 클릭해 내용을 수정하고 저장 버튼을 클릭해주세요</div>
                    </ModalHeader>

                    <ModalBody px="20px">
                        <Stack direction="column">
                            <Stack direction="column" pb="20px">
                                <div className="text-xl">제목</div>

                                <Stack direction="row" spacing={2}>
                                    <Input
                                        variant="outline"
                                        defaultValue={name}
                                        fontSize="3xl"
                                        py="20px"
                                        w="80%"
                                        value={name || ""}
                                        onChange={(event) => setName(event.target.value)}
                                    />
                                </Stack>
                            </Stack>

                            <Stack direction="column">
                                <div className="text-xl">사진 파일</div>
                                <Stack direction="row" spacing={2}>
                                    <InputGroup w="80%">
                                        <Input
                                            ref={inputRef}
                                            value={file ? file.name : initialTitleName}
                                            fontSize="3xl"
                                            color={file ? "black" : "#a8a8a8"}
                                            py="20px"
                                            isReadOnly
                                            focusBorderColor="none"
                                            _hover={{}}
                                        />
                                        <input
                                            style={{ display: "none" }}
                                            ref={inputRef}
                                            type="file"
                                            accept="image/*"
                                            onChange={fileChange}
                                        />
                                        {file != null && file != "" && (
                                            <InputRightElement
                                                children={<CloseIcon color="gray.500" />}
                                                p="20px"
                                                onClick={() => removeFile()}
                                                cursor="pointer"
                                            />
                                        )}
                                    </InputGroup>
                                    <Button
                                        colorScheme="red"
                                        fontSize="3xl"
                                        py="20px"
                                        px="10px"
                                        w="20%"
                                        onClick={openFileExplorer}
                                    >
                                        파일 선택
                                    </Button>
                                </Stack>
                            </Stack>
                        </Stack>
                    </ModalBody>

                    <ModalFooter p="20px">
                        <Button py="20px" mr="10px" fontSize="3xl" onClick={editModal.onClose}>
                            취소
                        </Button>
                        <Button py="20px" fontSize="3xl" onClick={() => updateTitleInfo()}>
                            저장
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <ProductAdditionModal additionModal={additionModal} setIsProductUpdated={props.setIsProductUpdated} />
        </div>
    );
};
export default ProductAndSolution;
